import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "redux/store";
import ConfigForm from "../../_elements/ConfigForm";
import toolActions from "redux/app/tool/actions";
import { IConfigInfo } from "redux/app/tool/@types";

type OwnProps = {};
type ConfigCreateProps = PropsFromRedux & OwnProps;
function ConfigCreate(props: ConfigCreateProps) {
	useEffect(() => {
		return () => {
			props.setConfigInfo(undefined);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			<ConfigForm
				action="Create"
				actionLabel="Add Config"
				onClose={() => props.toggleConfigAddModal()}
				type="create"
				isDisabled={false}
				handleActionClick={(config, changeLog?: string) => {
					props.configCreate(config, changeLog ?? "");
				}}
			/>
		</>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		toggleConfigAddModal() {
			dispatch(toolActions.document.configAddModalToggle());
		},
		setConfigInfo(config?: IConfigInfo) {
			dispatch(toolActions.document.toolConfigInfoSet(config));
		},
		configCreate(config: any, changeLog: string) {
			dispatch(toolActions.commands.toolConfigCreate(config, changeLog));
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ConfigCreate);
